import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component PinIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <PinIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <PinIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const PinIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      data-testid="PinIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="M2.585 5.739c-.78.78-.78 2.044 0 2.824l5.367 5.367.77 3.585a.99.99 0 0 0 .705.756 1 1 0 0 0 .98-.256l3.098-3.098 4.79 4.79a.998.998 0 1 0 1.412-1.412l-4.79-4.79 3.098-3.098a1 1 0 0 0 .291-.638 1 1 0 0 0-.253-.736 1 1 0 0 0-.545-.312l-3.578-.769-5.367-5.367a1.997 1.997 0 0 0-2.824 0zm12.723 4.552-1.797-.386a2 2 0 0 1-.993-.54L7.151 3.996 3.997 7.151l5.367 5.367c.272.272.46.617.54.993l.387 1.796z"
        clipRule="evenodd"
      />
    </svg>
  )
);
PinIcon.displayName = "PinIcon";
export default PinIcon;
